/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-08-25 20:05:12
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-14 10:40:32
 */
import * as types from '../../../mutation-types';
export default {
	[types.PAGE_LOADING](state, status) {
		state.vuex_loading = status;
	},
	[types.SET_SYSTEM_CONF](state, obj) {
		state.vuex_system_conf = obj;
	},
	// [types.COMMISSION_RULES](state, obj) {
	// 	state.vuex_commission_rules = obj;
	// },
	[types.NEW_FUNCS_VIEWED](state, val) {
		state.vuex_newFuncsViewed.push(val);
		localStorage.setItem('vuex_newFuncsViewed', JSON.stringify(state.vuex_newFuncsViewed));
	},
	[types.SET_PLATFORM](state, val) {
		state.vuex_platformId = val;
	},
};
